// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#emergency-transport-patient-list[data-v-1dedb348]{max-width:1280px;margin-left:auto;margin-right:auto}#emergency-transport-patient-list .add-btn[data-v-1dedb348],#emergency-transport-patient-list .setting-btn[data-v-1dedb348]{min-width:95px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
